import React, { useState } from 'react';
import './App.css';
import ControlRoom from './components/ControlRoom';
import CharacterChat from './components/CharacterChat';
import HoratioPanel from './components/HoratioPanel';
import IdeaAtlas from './components/IdeaAtlas';

import BlockchainArchive from './components/BlockchainArchive';
import Immortalize from './components/Immortalize';
import Opportunities from './components/Opportunities';
import EngagementTicker from './components/EngagementTicker';
import { trackTabPageView } from './analytics';
// import MoltbookTheatre from './components/MoltbookTheatre';

const HASH_TO_TAB = {
  'live': 'live',
  'control-room': 'live',
  'highlights': 'live',
  'wizard': 'live',
  'characters': 'characters',
  'nodes': 'nodes',
  'knowledge': 'nodes',
  'horatio': 'horatio',
  'opportunities': 'opportunities',
  'immortalize': 'imm',
  'vote': 'imm',
  'imm': 'imm',
};

const TAB_TO_HASH = {
  live: 'live',
  characters: 'characters',
  nodes: 'knowledge',
  horatio: 'horatio',
  imm: 'imm',
  opportunities: 'opportunities',
};

function App() {
  const [tab, setTab] = useState(() => {
    // Hash takes priority (for direct linking like #opportunities)
    const hash = window.location.hash.replace(/^#/, '').split('?')[0].toLowerCase();
    // Start a Scene (wizard) parked Jul 21 2026 — Discord performer retired with AA.
    if (hash && HASH_TO_TAB[hash]) {
      return HASH_TO_TAB[hash];
    }
    // Fall back to localStorage, then default (never land on parked wizard)
    const saved = localStorage.getItem('bitbard_current_tab');
    if (!saved || saved === 'wizard') return 'live';
    return saved;
  });

  // Track initial page load (run once on mount). Skips operator / Reply Ops traffic.
  React.useEffect(() => {
    const hash = window.location.hash.replace(/^#/, '').split('?')[0].toLowerCase();
    const saved = localStorage.getItem('bitbard_current_tab');
    const tabName = (hash && HASH_TO_TAB[hash])
      ? HASH_TO_TAB[hash]
      : (saved && saved !== 'wizard' ? saved : 'live');
    trackTabPageView(tabName);
  }, []); // Empty dependency array = run once on mount

  // Handle hash changes (e.g., user clicks back button)
  React.useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace(/^#/, '').split('?')[0].toLowerCase();
      if (hash && HASH_TO_TAB[hash]) {
        const tabName = HASH_TO_TAB[hash];
        setTab(tabName);
        trackTabPageView(tabName);
      }
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);


  // Save tab to localStorage when it changes (preserve state on refresh)
  React.useEffect(() => {
    localStorage.setItem('bitbard_current_tab', tab);
  }, [tab]);
  return (
    <div className="App">
      <EngagementTicker />
      <div className="bitbard-tabs">
        <button className={tab === 'live' ? 'active' : ''} onClick={() => { setTab('live'); window.location.hash = TAB_TO_HASH.live; }}>Troupe Feed ✨</button>
        <button className={tab === 'characters' ? 'active' : ''} onClick={() => { setTab('characters'); window.location.hash = TAB_TO_HASH.characters; }}>Character Chat</button>
        <button className={tab === 'nodes' ? 'active' : ''} onClick={() => { setTab('nodes'); window.location.hash = TAB_TO_HASH.nodes; }}>Knowledge Map</button>
        <button className={tab === 'horatio' ? 'active' : ''} onClick={() => { setTab('horatio'); window.location.hash = TAB_TO_HASH.horatio; }}>Ask Horatio</button>
        <button className={tab === 'imm' ? 'active' : ''} onClick={() => { setTab('imm'); window.location.hash = TAB_TO_HASH.imm; }}>Immortalize</button>
      </div>
      {tab === 'live' && <div className="scene-reader-container"><ControlRoom /></div>}
      {tab === 'characters' && <div className="character-reader-container"><div className="tab-header-block"><div className="console-header">Character Chat</div></div><CharacterChat /></div>}
      {tab === 'nodes' && <IdeaAtlas />}
      {tab === 'horatio' && <div className="character-reader-container"><div className="tab-header-block"><div className="console-header">Ask Horatio</div></div><HoratioPanel /></div>}
      {tab === 'imm' && <div className="scene-reader-container"><div className="tab-header-block"><div className="console-header">Immortalize: Monthly Poll</div></div><Immortalize /></div>}
      {tab === 'opportunities' && <div className="scene-reader-container"><Opportunities /></div>}
      {/* Temporary access: navigate via #archive in hash if desired */}
      {window.location.hash.replace(/^#/, '').toLowerCase() === 'archive' && (
        <div className="scene-reader-container"><div className="console-header" style={{marginBottom:6}}>Blockchain Archive</div><BlockchainArchive /></div>
      )}
    </div>
  );
}

export default App;
